import { InputNumberProps } from 'antd/lib/input-number'
import { watt } from '@/utils/form'
import InputNumber from './InputNumber'

const WattInput = ({ ...props }: InputNumberProps) => (
  <InputNumber {...props} {...watt} />
)

export default WattInput
